import {combineReducers} from 'redux'
import messageReplyListReducer from './messageReply';

export default combineReducers({
    messageReplyList: messageReplyListReducer,
})